import React from 'react';
import background from '../../assets/nasa.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoNasa extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="NEAR SPACE"
        subtag="Washington, D.C. (US)"
        description="NASA"
        paragraph="The National Aeronautics and Space Administration is an independent agency of the U.S. Federal Government responsible for the civilian space program, as well as aeronautics and space research."
        background={background}
     />
  
  );
 }
}   

export default InfoNasa;